var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_516_14716)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.47217,
    y: 2.5,
    width: 40.028,
    height: 39.2239,
    fill: "#78C0AB",
    stroke: "white",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9767 17.72C16.9869 17.6186 16.9732 17.5161 16.9367 17.4209C16.9003 17.3257 16.842 17.2403 16.7667 17.1717L15.21 15.2825V15H20.0417L23.7767 23.2542L27.06 15H31.6667V15.2825L30.3358 16.5667C30.2794 16.6102 30.2359 16.6682 30.21 16.7346C30.184 16.8009 30.1765 16.8731 30.1883 16.9433V26.3883C30.1765 26.4586 30.184 26.5307 30.21 26.5971C30.2359 26.6634 30.2794 26.7215 30.3358 26.765L31.6358 28.05V28.3333H25.0992V28.0508L26.4458 26.7342C26.5783 26.6008 26.5783 26.5617 26.5783 26.3583V18.7233L22.835 28.3017H22.33L17.9717 18.7233V25.1433C17.9358 25.4125 18.025 25.685 18.2133 25.88L19.9642 28.02V28.3017H15V28.02L16.75 25.88C16.8426 25.7834 16.9113 25.6664 16.9507 25.5385C16.99 25.4106 16.9989 25.2753 16.9767 25.1433V17.72Z",
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_516_14716",
    x: 0.972168,
    y: 0,
    width: 53.0278,
    height: 52.2239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_14716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_516_14716",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.8db547b7c56d0421c2c8447689419723.svg";
export { ForwardRef as ReactComponent };